'use client';

import { useState } from 'react';
import { CheckIcon } from './Icons';

const API_URL = process.env.NEXT_PUBLIC_API_URL || 'http://localhost:3028/api';

export default function ContactForm() {
  const [form, setForm] = useState({ name: '', email: '', phone: '', message: '' });
  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [apiError, setApiError] = useState('');

  function validate() {
    const newErrors = {};
    if (!form.name.trim()) newErrors.name = true;
    if (!form.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) newErrors.email = true;
    if (!form.message.trim()) newErrors.message = true;
    return newErrors;
  }

  function handleChange(e) {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors((prev) => { const next = { ...prev }; delete next[name]; return next; });
    }
    if (apiError) setApiError('');
  }

  async function handleSubmit(e) {
    e.preventDefault();
    const newErrors = validate();
    if (Object.keys(newErrors).length > 0) { setErrors(newErrors); return; }

    setLoading(true);
    setApiError('');

    try {
      const res = await fetch(`${API_URL}/contact-requests`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: form.name.trim(),
          email: form.email.trim(),
          phone: form.phone.trim(),
          message: form.message.trim()
        })
      });

      const data = await res.json();

      if (!res.ok) {
        if (res.status === 429) {
          setApiError('Hai inviato troppe richieste. Riprova tra un\'ora.');
        } else if (data?.error?.message) {
          setApiError(data.error.message);
        } else {
          setApiError('Si è verificato un errore. Riprova più tardi.');
        }
        return;
      }

      setSubmitted(true);
    } catch {
      setApiError('Impossibile inviare il messaggio. Verifica la connessione e riprova.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="form-card">
      {submitted && (
        <div className="form-success">
          <div className="check-icon"><CheckIcon size={14} color="#fff"/></div>
          <div>
            <h4>Messaggio inviato</h4>
            <p>Grazie per averci scritto. Ti rispondiamo entro 24 ore lavorative all&apos;indirizzo email indicato.</p>
          </div>
        </div>
      )}
      {apiError && (
        <div className="form-error" style={{ background: '#FEF2F2', border: '1px solid #FECACA', borderRadius: 8, padding: '12px 16px', marginBottom: 16, color: '#DC2626', fontSize: 14 }}>
          {apiError}
        </div>
      )}
      <form onSubmit={handleSubmit} noValidate>
        <div className="form-row">
          <label>Nome e cognome <span className="req">*</span></label>
          <input
            type="text"
            name="name"
            placeholder="Mario Rossi"
            value={form.name}
            onChange={handleChange}
            disabled={loading || submitted}
            style={errors.name ? { borderColor: '#ef4444' } : undefined}
          />
        </div>
        <div className="form-row">
          <label>Email <span className="req">*</span></label>
          <input
            type="email"
            name="email"
            placeholder="nome@studiomedico.it"
            value={form.email}
            onChange={handleChange}
            disabled={loading || submitted}
            style={errors.email ? { borderColor: '#ef4444' } : undefined}
          />
        </div>
        <div className="form-row">
          <label>Telefono <span style={{ color: 'var(--text-3)', fontWeight: 400 }}>(opzionale)</span></label>
          <input
            type="tel"
            name="phone"
            placeholder="+39 ..."
            value={form.phone}
            onChange={handleChange}
            disabled={loading || submitted}
          />
        </div>
        <div className="form-row">
          <label>Messaggio <span className="req">*</span></label>
          <textarea
            name="message"
            placeholder="Raccontaci del tuo studio e di cosa hai bisogno..."
            value={form.message}
            onChange={handleChange}
            disabled={loading || submitted}
            style={errors.message ? { borderColor: '#ef4444' } : undefined}
          />
        </div>
        <button type="submit" className="btn btn-primary btn-lg btn-block" disabled={loading || submitted}>
          {loading ? 'Invio in corso...' : 'Invia messaggio'}
        </button>
        <p style={{ fontSize: 12, color: 'var(--text-3)', marginTop: 14, textAlign: 'center', marginBottom: 0 }}>
          Inviando il modulo accetti la nostra <a href="#" style={{ color: 'var(--text-2)' }}>Privacy Policy</a>.
        </p>
      </form>
    </div>
  );
}
